import { render } from "./NavigatorSuggestions.vue?vue&type=template&id=0c318d03&scoped=true"
import script from "./NavigatorSuggestions.vue?vue&type=script&lang=js"
export * from "./NavigatorSuggestions.vue?vue&type=script&lang=js"

import "./NavigatorSuggestions.vue?vue&type=style&index=0&id=0c318d03&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c318d03"],['__file',"resources/js/components/NavigatorSuggestions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c318d03"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c318d03', __exports__)) {
    api.reload('0c318d03', __exports__)
  }
  
  module.hot.accept("./NavigatorSuggestions.vue?vue&type=template&id=0c318d03&scoped=true", () => {
    api.rerender('0c318d03', render)
  })

}


export default __exports__